import React from 'react';
import DragDropContainer from '../LevelEditor/DropZone/DragDropContainer';

function DragDropPrefab({ item, handleClick, onEnter, onLeave, active }) {
    return (
        <DragDropContainer
            defaultDropId="editor-canvas"
            targetKey="game-block"
            dragData={{ id: item.id }}
            customDragElement={<img src={item.src} className="draggable-element" alt={item.name} style={{ filter: `hue-rotate(${item.previewHue * -1}deg)` }} />}
            onClick={handleClick}
            className={`category-prefab-item${active ? ' active' : ''}`}
        >
            <div onMouseEnter={onEnter} onPointerEnter={onEnter} onMouseLeave={onLeave} onPointerLeave={onLeave}>
                <img className="category-prefab-img" src={item.src} alt={item.name} style={{ filter: `hue-rotate(${item.previewHue * -1}deg)` }} />
            </div>
        </DragDropContainer>
    );
}

function Prefab({ item, handleClick, onEnter, onLeave, active }) {
    return (
        <div onClick={handleClick} className={`category-prefab-item${active ? ' active' : ''}`} onMouseEnter={onEnter} onPointerEnter={onEnter} onMouseLeave={onLeave} onPointerLeave={onLeave}>
            <img className="category-prefab-img" src={item.src} alt={item.name} style={{ filter: `hue-rotate(${item.previewHue * -1}deg)` }} />
        </div>
    );
}

class PrefabItem extends React.Component {
    onEnter = () => {
        const { setHoveredPrefabName, item } = this.props;
        setHoveredPrefabName(item.name);
    };

    onLeave = () => {
        const { setHoveredPrefabName } = this.props;
        setHoveredPrefabName('');
    };

    handleClick = () => {
        const { handleItemClick, item } = this.props;
        handleItemClick(item);
    };

    render = () => {
        const { item, draggable, active } = this.props;

        if (draggable) {
            return <DragDropPrefab item={item} handleClick={this.handleClick} onEnter={this.onEnter} onLeave={this.onLeave} active={active} />;
        }

        return <Prefab item={item} handleClick={this.handleClick} onEnter={this.onEnter} onLeave={this.onLeave} active={active} />;
    };
}

export default PrefabItem;
